<template>
  <div class="service-section">
    <div class="section-header">
      <h3 class="section-title">{{ title }}</h3>
    </div>
    <div class="service-grid">
      <div
        v-for="item in services"
        :key="item.label"
        class="service-item"
        :class="{ disabled: item.disabled }"
        @click="handleClick(item)"
      >
        <i :class="`el-icon-${item.icon}`"></i>
        <span>{{ item.label }}</span>
        <i v-if="!item.disabled" class="el-icon-arrow-right arrow-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceSection",
  props: {
    title: {
      type: String,
      default: "",
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(item) {
      if (!item.disabled) {
        this.$emit("click", item);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.service-section {
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .section-header {
    margin-bottom: 16px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin: 0;
    }
  }

  .service-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .service-item {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    border-radius: 10px;
    background-color: #fafbfc;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover:not(.disabled) {
      background-color: rgba(66, 134, 245, 0.06);
      transform: translateY(-1px);

      i:first-child {
        color: #4286f5;
      }

      span {
        color: #4286f5;
      }
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;

      i:first-child {
        color: #c0c4cc;
      }

      span {
        color: #909399;
      }
    }

    i:first-child {
      font-size: 18px;
      color: #909399;
      margin-right: 10px;
      flex-shrink: 0;
      transition: color 0.2s ease;
    }

    span {
      flex: 1;
      font-size: 14px;
      color: #606266;
      transition: color 0.2s ease;
    }

    .arrow-icon {
      font-size: 12px;
      color: #c0c4cc;
      margin-left: 8px;
    }
  }
}
</style>
